require('../bootstrap');
require('../plugins');
import Swiper, {SwiperOptions} from "../../../node_modules/swiper/swiper-bundle.esm.js";

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: JA (Japanese; 日本語)
 */
$.extend($.validator.messages, {
  required: "このフィールドは必須です。",
  remote: "このフィールドを修正してください。",
  email: "有効なEメールアドレスを入力してください。",
  url: "有効なURLを入力してください。",
  date: "有効な日付を入力してください。",
  dateISO: "有効な日付（ISO）を入力してください。",
  number: "有効な数字を入力してください。",
  digits: "数字のみを入力してください。",
  creditcard: "有効なクレジットカード番号を入力してください。",
  equalTo: "同じ値をもう一度入力してください。",
  extension: "有効な拡張子を含む値を入力してください。",
  maxlength: $.validator.format("{0} 文字以内で入力してください。"),
  minlength: $.validator.format("{0} 文字以上で入力してください。"),
  rangelength: $.validator.format("{0} 文字から {1} 文字までの値を入力してください。"),
  range: $.validator.format("{0} から {1} までの値を入力してください。"),
  step: $.validator.format("{0} の倍数を入力してください。"),
  max: $.validator.format("{0} 以下の値を入力してください。"),
  min: $.validator.format("{0} 以上の値を入力してください。")
});

$(function () {
  // Setup From Validation
  setupFromValidation();
});

function removeErrorMsgs(element) {
  element.closest('.form-group').find('.error-msg').remove();
}

function showErrorMsgs(error, element) {
  const e = element.closest('.form-group').find('.error-msg');
  if (e.length > 0) {
    e.text(error.get(0).innerText);
  } else {
    element.closest('.form-group').append('<div class="error-msg invalid-feedback d-block">' + error.get(0).innerText + '</div>');
  }
}

$.validator.addMethod("yearMonth", function (dateStr, element) {
  dateStr = dateStr.replace(/\s+/g, "");
  return this.optional(element) || dateStr.match(/[\d]{2}\/[\d]{2}$/);
}, "有効な日付を入力してください。");

function setupFromValidation() {
  $('.validateform').validate({
    lang: 'ja',
    // rules, options, etc.,
    onfocusout: function(element) {
      // "eager" validation
      this.element(element);
    },
    rules: {
      'card_number': {
        required: true,
        creditcard: true
      },
      'card_exp': {
        required: true,
        yearMonth: true
      },
      'card_ccv': {
        required: true,
        number: true
      }
    },
    errorPlacement: function (error, element) {
      // showErrorMsgs(error, element);
    },
    success: function (element) {
      removeErrorMsgs(element);
    },
    submitHandler: function (form) {
      // normal submit form
      form.submit();
    }
  });

  $('.validateform input').on('keyup blur', function () {
    if ($('.validateform').valid()) {
      $('button.btn').prop('disabled', false);
    } else {
      $('button.btn').prop('disabled', 'disabled');
    }
  });
}



function commaSeparateNumber(val) {
  // remove sign if negative
  var sign = 1;
  if (val < 0) {
    sign = -1;
    val = -val;
  }

  // trim the number decimal point if it exists
  let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();

  while (/(\d+)(\d{3})/.test(num.toString())) {
    // insert comma to 4th last position to the match number
    num = num.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
  }

  // add number after decimal point
  if (val.toString().includes('.')) {
    num = num + '.' + val.toString().split('.')[1];
  }

  // return result with - sign if negative
  return sign < 0 ? '-' + num : num;
}
window.commaSeparateNumber = commaSeparateNumber;

$(document).ready(function () {
  $('#top-menu .nav-toggle').click(function () {
    if ($('#top-menu').hasClass('in')) {
      $('#wrapper-in').css('height', 'auto');
    } else {
      $('#wrapper-in').height($('.top-menu').height());
    }
    $('#top-menu .sidebar-nav').toggleClass('menu-open');
    $('#top-menu').toggleClass('in');
  });

  $('.toggle-password-field').on('click', function () {
    const e = $(this);
    if (e.hasClass('iconc-eye-off')) {
      e.removeClass('iconc-eye-off');
      e.addClass('iconc-eye');
      e.prev().attr('type', 'text');
    } else {
      e.removeClass('iconc-eye');
      e.addClass('iconc-eye-off');
      e.prev().attr('type', 'password');
    }
  })

  var swiperMain = new Swiper(".main-slider", {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 18,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 10000,
    },
    breakpoints: {
      577: {
        spaceBetween: 45,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  var swiperCard = new Swiper(".digital-card-slider", {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 5,
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 10000,
    },
    breakpoints: {
      577: {
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  var swiperPaymentCard = new Swiper(".payment-card-slider", {
    slidesPerView: "auto",
    spaceBetween: 20,
  });

  $('.no-payment-method').on('click', function (e) {
    e.preventDefault();

    Swal.fire({
      title: '登録されたお支払方法がありません。\n先にお支払方法を登録しますか？',
      showCancelButton: true,
      confirmButtonText: '確認',
      cancelButtonText: 'キャンセル',
      icon: 'warning'
    }).then((result) => {
      if (result.value) {
        location.href = '/settings/payment';
      }
    });
  });

  $('#purchase-group-event-type-select').change(function() {
    let purchaseGroupEventTypeId = $(this).val();
    $('#purchase-card-coins-span').html(commaSeparateNumber(groupEventCoins[purchaseGroupEventTypeId]));
  });
  $('.card-purchase-button').click(function() {
    var purchaseGroupEventTypeId = $('#purchase-group-event-type-select').val();
    var cardCoins = groupEventCoins[purchaseGroupEventTypeId];
    var count = $('#card-count').val();
    $('#purchase-card-count').val(count);
    $('#purchase-group-event-type').val(purchaseGroupEventTypeId);
    $('#card-coins').html(commaSeparateNumber(cardCoins));
    $('#total-coins').html(commaSeparateNumber(count * cardCoins));

    $('#purchaseConfirmModal').modal();
  });
  $('#purchase-confirm').click(function() {
    var purchaseGroupEventTypeId = $('#purchase-group-event-type-select').val();
    var cardCoins = groupEventCoins[purchaseGroupEventTypeId];
    var count = $('#card-count').val();
    var totalCoins = count * cardCoins;
    var currentCoins = $('#currentCoins').val();
    if (totalCoins > currentCoins) {
      Swal.fire({
        title: '現在所持しているコインが不足しています。\nコインを購入した後、もう一度お試しください。\nまず、コイン購入ページに移行しますか？',
        showCancelButton: true,
        confirmButtonText: '確認',
        cancelButtonText: 'キャンセル',
        icon: 'warning'
      }).then((result) => {
        if (result.value) {
          location.href='/coin';
        }
      });
    } else {
      $(this).attr('disabled', true);
      $('#card-purchase-form').submit();
    }
  });

  $('.consume-group-event-type-select').change(function() {
    let groupId = $(this).data('group-id');
    let purchaseGroupEventTypeId = $(this).val();
    let groupEventTicketCounts = groupData[groupId][purchaseGroupEventTypeId];
    let cardGroup = $(this).closest('.consume-card-group');
    $(cardGroup).find('.consume-card-count-span').html(commaSeparateNumber(groupEventTicketCounts));

    let cardCountSelect = $(cardGroup).find('.card-count');
    cardCountSelect.empty();
    for (let i = 1; i <= Math.min(groupEventTicketCounts, 10); i++) {
      let option = $('<option></option>').attr('value', i).text(i);
      cardCountSelect.append(option);
    }
  });
  $('.consume-card-button').on('click', function () {
    let groupName = $(this).data('group-name');
    let cardGroup = $(this).closest('.consume-card-group');
    let count = $(cardGroup).find('.card-count').val();
    let idolId = $(cardGroup).find('.idol').val();
    let idolName = $(cardGroup).find('.idol option:selected').text();
    let groupEventTypeId = $(cardGroup).find('.consume-group-event-type-select').val();
    let groupEventTypeText = '参加券';
    if ($(cardGroup).find('.consume-group-event-type-select option:selected').length > 0)
      groupEventTypeText = $(cardGroup).find('.consume-group-event-type-select option:selected').text();

    Swal.fire({
      title: groupName + 'の' + groupEventTypeText + count + '枚を' + idolName + 'に消費しますか？',
      showCancelButton: true,
      confirmButtonText: '確認',
      cancelButtonText: 'キャンセル',
      icon: 'warning'
    }).then((result) => {
      if (result.value) {
        $(this).attr('disabled', true);
        let form = cardGroup.find('.consume-card-form');
        $(form).find('input[name=idol_id]').val(idolId);
        $(form).find('input[name=count]').val(count);
        $(form).find('input[name=group_event_type_id]').val(groupEventTypeId);
        $(form).submit();
      }
    });
  });
});
